module.exports = __webpack_public_path__ + "static/media/shoes.4cb01c7d.jpg";